import * as React from 'react';
import { toast } from 'react-toastify';

import { Table, Button, Typography } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import { CHECKOUT_ELEMENTS_URL } from 'settings';
import Truncate from 'v2/components/Shared/TruncateText';
import type { ProductOffer } from 'v2/interfaces/product';

type PricesListProps = {
  offer: ProductOffer;
};

type ProductPrice = ProductOffer['prices'][0];

function PricesList({ offer }: PricesListProps) {
  function mountOfferLink(price: ProductPrice) {
    return `${CHECKOUT_ELEMENTS_URL}/${offer.key}?currency=${price.currency.code}`;
  }

  function copyLinkToClipboard(link: string) {
    navigator.clipboard.writeText(link);
    toast.success('Link copiado para a área de transferência');
  }

  function mountOfferCurrency(price: ProductPrice) {
    return `${price.currency.code} (${price.currency.name})`;
  }

  if (!offer.prices?.length) return null;

  const columns = [
    {
      title: 'Moeda',
      dataIndex: 'currency',
      key: 'currency',
      render: (_: any, price: ProductPrice) => (
        <Typography.Text className='whitespace-nowrap' id={`links-modal-offer-currency-${price.currency.code}`}>
          <Truncate count={25}>{mountOfferCurrency(price)}</Truncate>
        </Typography.Text>
      )
    },
    {
      title: 'Valor',
      dataIndex: 'value',
      key: 'value',
      width: 112,
      render: (_: any, price: ProductPrice) => (
        <Typography.Text id={`links-modal-offer-price-${price.currency.code}`}>
          {price.value.toLocaleString('pt-BR', {
            style: 'currency',
            currency: price.currency.code
          })}
        </Typography.Text>
      )
    },
    {
      title: 'Página de pagamento (Eduzz Checkout Elements)',
      dataIndex: 'link',
      key: 'link',
      width: 300,
      render: (_: any, price: ProductPrice) => (
        <div className='border-outline-default flex items-center gap-2 border py-1 pr-2 pl-3.25'>
          <Icon.Link  />
          <a
            className='text-content-body max-w-50.75 truncate text-sm leading-6 hover:underline'
            id={`links-modal-offer-link-${price.currency.code}`}
            href={mountOfferLink(price)}
            target='_blank'
            rel='noreferrer'
          >
            {mountOfferLink(price)}
          </a>
          <Button
            type='text'
            id={`links-modal-copy-button-${price.currency.code}`}
            icon={<Icon.Copy  />}
            onClick={() => copyLinkToClipboard(mountOfferLink(price))}
          />
        </div>
      )
    }
  ];

  return <Table size='small' dataSource={offer.prices} columns={columns} rowKey='id' pagination={false} />;
}

export { PricesList };
